import TemplateNames from './TemplateNames';

export default {
  title: 'Correos automáticos',
  labels: {
    empty_list: 'No se encontraron plantillas',
    load_failed: 'No se pudieron cargar tus correos automáticos. Recarga la página o contacta con soporte.',
    on: 'Activo',
    off: 'Inactivo',
  },
  fields: {
    name: 'Nombre',
    messages_delivered: 'Mensajes entregados',
    open_rate: 'Tasa de apertura',
    click_rate: 'Tasa de clics',
    status: 'Estado',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Error al actualizar el estado',
    failed_to_load_data: 'Error al cargar datos',
  },
};
